export default "__VITE_ASSET__D1xRXtmq__"